<q9-content-loader [isLoading]="loading"></q9-content-loader>

<form #form="ngForm" [formGroup]="addNodeForm" novalidate *ngIf="!loading">
  <div mat-dialog-title>
    <span>
      Create New {{ ''.concat(data.type.charAt(0).toUpperCase(), data.type.slice(1)) }} Node
    </span>
    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <mat-dialog-content class="inputs-container">
    <q9-text-field
      [label]="'POPUPS.NODE_NAME' | translate"
      [isRequired]="nameRequired"
      [placeholder]="'POPUPS.CREATE_NODE_TITLE_PH' | translate"
      formControlName="name"></q9-text-field>

    <q9-text-field
      [isRequired]="customIdRequired"
      [label]="'POPUPS.ID' | translate"
      [placeholder]="'POPUPS.CREATE_NODE_ID_PH' | translate"
      formControlName="customId"></q9-text-field>

    <q9-textarea-field
      formControlName="description"
      [label]="'POPUPS.DESCRIPTION' | translate"
      [placeholder]="'POPUPS.CREATE_NODE_DESCR_PH' | translate"
      [maxRows]="10"
      [minRows]="3"></q9-textarea-field>

    <!--Disabled GDPR toggle as data privacy is not used anymore.-->
    <!--    <mat-slide-toggle-->
    <!--      class="q9-slide-toggle"-->
    <!--      formControlName="gdprEnabled"-->
    <!--      *ngIf="refModelGdprEnabled">-->
    <!--      {{ 'GDPR.ENABLED_LABEL' | translate }}-->
    <!--    </mat-slide-toggle>-->

    <q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <q9-secondary-button mat-dialog-close>{{ 'POPUPS.CANCEL' | translate }}</q9-secondary-button>

    <q9-primary-button (click)="form.onSubmit($event); onSubmit()">
      {{ 'POPUPS.CREATE' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</form>
